import React from 'react';
import HOCLoader from '../HOC/HOCLoader.jsx';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actions from '../../actions';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import Axios from 'axios';
import { getCookies } from '../../utils/getToken.js';
import { SERVER_URL } from '../../utils/config/constants.js';
import { format, render, cancel, register } from 'timeago.js';
import dateFormat, { masks } from "dateformat"

class SideNotificationList extends React.Component {
    constructor(props) {
        super();
        this.state = {
            order: 'desc',
            orderBy: 'created_at',
            selected: [],
            data: props.notificationData,
            page: 0,
            rowsPerPage: 10,
            clickValue: '',
            item: {},
            loader: false,
            singleNotification: null
        };
    }

    actionCallbacks(action, res) {
        if (action === 'view') {
            this.setState({ clickValue: 'view', item: res });
        }
    }
    componentDidMount() {
        this.reloadData = setInterval(() => {
            // this.props.notificationListAction();
            console.log("modified web 3")
        }, 5000000)

        const notdata = this.props.notificationListAction();
        console.info(notdata)
        /* this.willFocus = navigation.addListener(
            'willFocus',
            () => {
                this.props.notificationListAction();
            }
        )

        this.didBlur = navigation.addListener(
            'didBlur',
            () => {
                this.props.notificationListAction();
            }
        ) */
    }

    componentWillUnmount() {
        /**  this.didBlur.remove();
          this.willFocus.remove(); **/
        clearInterval(this.reloadData)
    }

    readNotification = (id) => {
        var authToken = getCookies();
        Axios({
            method: 'post',
            url: `${SERVER_URL}/notifications/read`,
            data: {
                notID: id
            },
            headers: { 'x-auth-token': authToken }
        }).then(resJson => {
            console.log("Successss:::", resJson.data)
        })
    }
    componentDidUpdate(prevProps, prevState) {
        if (
            prevProps.notificationData.length !==
            this.props.notificationData.length
        ) {
            this.setState({
                data: this.props.notificationData,
                loader: this.props.notificationLoader
            });
        }
    }
    clickNotification = notification => {
        console.log("NAKNDANDNAND:::::", notification.key)
        this.props.notificationListAction();
        console.info(notification)
        this.setState({
            singleNotification: notification
        },()=>this.readNotification(notification.id))

    };
    okHandle = ()=>{
        this.setState({
            singleNotification:null
        },()=>this.props.notificationListAction())
    }
    render() {
        const { data, rowsPerPage, page } = this.state;
        const { notificationData } = this.props;

        //View Redirection
        if (this.state.clickValue) {
            if (this.state.item.route == 'BookingDetail') {
                this.props.history.push({
                    pathname:
                        this.state.item.webroute +
                        '/' +
                        this.state.item.notification.payload.additionalData
                            .params.bookingDetail.key,
                    bookingId: this.state.item.notification.payload
                        .additionalData.params.bookingDetail.key
                });
            } else if (this.state.item.route == 'Offers') {
                this.props.history.push({
                    pathname: this.state.item.webroute
                });
            } else if (this.state.item.route == 'Available Services') {
                this.props.history.push({
                    pathname: "/provider/pendingbooking"
                });
            }
        }
        //View Redirection


        return (
            <HOCLoader loading={this.props.notificationLoader}>
                <ul>
                    {notificationData.length == 0 && (
                        <li>
                            <a>
                                <h5>No Notification Found</h5>
                            </a>
                        </li>
                    )}
                    {
                        console.info(this.state.singleNotification)
                    }
                    {this.state.singleNotification ?
                        <div>
                            <p style={{ fontSize: "16px", fontWeight: "600", color: "black" }} >
                                {this.state.singleNotification.heading}
                            </p>
                            {/* <p style={{ margin: "0",fontSize:"6px" }} >{format(this.state.singleNotification.created_at)}</p> */}
                            <p>{this.state.singleNotification.message}</p>
                            <p style={{ margin: "20px 0 5px 0",fontSize:"12px" }} >{dateFormat(this.state.singleNotification.created_at, "dddd, mm/dd/yyyy")}</p>
                            <button
                            style={{height:"35px",padding:"8px",width:"88px",marginTop:"28px"}}
                                className="custom-button"
                                onClick={() => this.okHandle()}
                            >
                                OK
                            </button>
                        </div>
                        :
                        notificationData.map((noti, index) => {
                            return (
                                <li
                                    key={index}
                                    onClick={() => this.clickNotification(noti)}
                                >
                                    <a href="javascript:void(0);">
                                        {/* {noti.is_read == 2 ?
                                            <div className="badge text-uppercase text-white bg-danger" style={{ float: "right" }}>New</div> : null} */}
                                        {noti.is_read == 2 ?
                                        <p style={{ fontSize: "16px", fontWeight: "600", color: "black" }} >
                                        {noti.heading}
                                    </p> 
                                    :
                                    <p style={{ fontSize: "16px", color: "black" }} >
                                            {noti.heading}
                                        </p>
                                    }
                                        
                                        <p style={{ margin: "10px 0 5px 0" }} >{ dateFormat(noti.created_at, "dddd, mm/dd/yyyy")}</p>

                                        {/* <p>  
                                        {noti.message}
                                        </p> */}
                                    </a>
                                </li>
                            );
                        })}

                </ul>
            </HOCLoader>
        );
    }
}

const mapStateToProps = ({ notification }) => {
    return {
        notificationData: notification.notificationData,
        notificationLoader: notification.notificationLoader
    };
};
const composedComponent = compose(
    connect(
        mapStateToProps,
        actions
    )
);

export default composedComponent(injectIntl(withRouter(SideNotificationList)));



// WEBPACK FOOTER //
// ./src/components/Customer/SideNotificationList.jsx